import { render, staticRenderFns } from "./Bons.vue?vue&type=template&id=4346d0e5&"
import script from "./Bons.vue?vue&type=script&lang=js&"
export * from "./Bons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports